const OptimizedImage = ({
  alt,
  sources = [],
  fallback,
  width,
  height,
  ...rest
}) => {
  return (
    <picture>
      {sources.map((s, i) => (
        <source key={i} {...s} />
      ))}
      <img
        alt={alt}
        width={width}
        height={height}
        decoding="async"
        loading="lazy"
        {...fallback}
        {...rest}
      />
    </picture>
  );
};

export default OptimizedImage;
